RivalIQ.apps.LandscapeSettings.module('views', function (views) {

    'use strict';

    views.AccountEmail = RivalIQ.apps.LandscapeSettings.views.Email.extend({
        getStateManager: function () {
            // account settings
            return RivalIQ.state.account;
        }
    });
});
